import { render, staticRenderFns } from "./pinterest.vue?vue&type=template&id=2a68972a&"
import script from "./pinterest.vue?vue&type=script&lang=js&"
export * from "./pinterest.vue?vue&type=script&lang=js&"
import style0 from "./pinterest.vue?vue&type=style&index=0&id=2a68972a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports